module.exports = __webpack_public_path__ + "img/1.9ed1c2d4.svg";